import { Anchor, Modal } from "@mantine/core";
import type { MRT_ColumnDef } from "mantine-react-table-open";
import { useState } from "react";
import type { MeteringServiceProvider } from "../../../../utils/backend-types";
import { HistoryTab } from "../../../HistoryTab/HistoryTab";
import { METERING_SERVICE_PROVIDER_FIELD_LABELS } from "../MeteringServiceProviderTable";

function getHistoryColumn(): MRT_ColumnDef<MeteringServiceProvider> {
  return {
    accessorKey: "id",
    header: "Historie",
    size: 100,
    enableEditing: false,
    Cell: ({ row }) => <HistoryCell id={row.original.id} />
  };
}

interface HistoryCellProps {
  id: number;
}

interface MeteringServiceProviderHistoryModalProps {
  onClose: () => void;
  id: number;
}

function HistoryCell({ id }: HistoryCellProps) {
  const [selectedProviderId, setSelectedProviderId] = useState<number | null>(
    null
  );

  return (
    <>
      <Anchor
        component="button"
        type="button"
        onClick={() => setSelectedProviderId(id)}
      >
        Anzeigen
      </Anchor>

      {selectedProviderId && (
        <MeteringServiceProviderHistoryModal
          id={id}
          onClose={() => setSelectedProviderId(null)}
        />
      )}
    </>
  );
}

function MeteringServiceProviderHistoryModal({
  id,
  onClose
}: MeteringServiceProviderHistoryModalProps) {
  return (
    <Modal opened size="xl" title="Historie" onClose={onClose}>
      <HistoryTab
        entityId={id}
        entityType="meteringServiceProvider"
        fieldNameToLabelMap={METERING_SERVICE_PROVIDER_FIELD_LABELS}
      />
    </Modal>
  );
}

export { getHistoryColumn };
